import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AbstractService} from '../abstract.service';
import {ResponseDto} from '../../dto/response-dto';
import {AffectedArea} from '../../dto/sigevs/sanitary-analysis.model';

@Injectable({
    providedIn: 'root'
})
export class AffectedAreaService extends AbstractService {

    private readonly URL = this.API_REST_SIGEVS + '/affected-area';

    constructor(http: HttpClient) {
        super(http);
    }

    findAllWithoutShape(): Observable<ResponseDto<AffectedArea[]>> {
        return this.http.get<ResponseDto<AffectedArea[]>>(this.URL);
    }

    findAllByIds(ids: number[]): Observable<ResponseDto<AffectedArea[]>> {
        return this.http.post<ResponseDto<AffectedArea[]>>(`${this.URL}/ids`, ids);
    }

    findById(id: number): Observable<ResponseDto<AffectedArea>> {
        return this.http.get<ResponseDto<AffectedArea>>(`${this.URL}/${id}`);
    }


    save(area: AffectedArea): Observable<ResponseDto<AffectedArea>> {
        return this.http.post<ResponseDto<AffectedArea>>(this.URL, area);
    }
}
